import React, { useMemo, useState } from "react";

import {
  Layout,
  Menu,
  Avatar,
  Drawer,
  Badge,
  Switch,
  Grid,
  Card,
  Row,
  Col,
  Typography,
  Divider,
  Progress,
  Button,
  Space,
} from "antd";

import { motion, AnimatePresence } from "framer-motion";
import RoyaltyATMScan from "./Product/RoyaltyATMScan";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  UserOutlined,
  DashboardOutlined,
  ShoppingCartOutlined,
  TruckOutlined,
  AppstoreOutlined,
  TeamOutlined,
  SettingOutlined,
  BarChartOutlined,
  InboxOutlined,
  CloseOutlined,
  LogoutOutlined,
  
} from "@ant-design/icons";

import {

  ReceiptLongOutlined,
} from "@mui/icons-material";

import YearSelector from "../../api/context/YearSelector";
import CustomerRoyalty from "./Product/DailySales/CustomerRoyalty/CustomerRoyalty";
import Product from "./Product/Product";
import Purchase from "./Product/Purchase";
import ProductList from "./Product/ProductList";
import DashboardCards from "./Cards/DashboardCards";
import PrepaidCard from "./PrepaidCard/PrepaidCard";
import UserManagement from "./Register/UserManagement";
import DailySales from "./Product/DailySales/DailySales";
import CreateShipment from "./CreateShipment/CreateShipment";
import ShippingTrip from "./CreateShipment/ShippingTrip";
import ShippingTripList from "./CreateShipment/ShippingTripList";
import UserProfile from "./Profile/UserProfile";
import CarPurchaseAgreement from "./Product/Carpurchase/CarPurchaseAgreement";
import CarAgreementReceipt from "./Product/Carpurchase/CarAgreementReceipt";
import GoodsItemList from "./CreateShipment/GoodsItemList";
import Logout from "./Profile/Logout";
import AdminCustomerTable from "./Product/DailySales/CustomerRoyalty/AdminCustomerTable";
import ProductQRCode from "./Product/ProductQRCode";
import InstantProductTransaction from "./Product/InstantProductTransaction";
import logo from "./Logo/zulu.png";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;
const { Title, Text } = Typography;

const AdminDashboard = () => {
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const [activeComponent, setActiveComponent] =
    useState("dashboard");

  const [productPopup, setProductPopup] =
    useState(false);

  // =========================================
  // THEME
  // =========================================
  const theme = useMemo(() => {
    return {
      primary: "#0B6E4F",

      background: darkMode ? "#07130F" : "#F4F7F6",

      sider: darkMode ? "#0E1C17" : "#ffffff",

      header: darkMode
        ? "rgba(14,28,23,0.92)"
        : "rgba(255,255,255,0.92)",

      card: darkMode ? "#12231D" : "#ffffff",

      border: darkMode ? "#1F3A31" : "#E5ECE8",

      text: darkMode ? "#F9FAFB" : "#111827",

      textSecondary: darkMode ? "#9CA3AF" : "#6B7280",

      hover: darkMode
        ? "rgba(11,110,79,0.18)"
        : "rgba(11,110,79,0.08)",
    };
  }, [darkMode]);

  // =========================================
  // MENU
  // =========================================
  const menuItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },

    {
      key: "products",
      icon: <AppstoreOutlined />,
      label: "Add Products",
    },

    {
      key: "purchase",
      icon: <ShoppingCartOutlined />,
      label: "Purchase",
    },

    {
      key: "generateproductqr",
      icon: <ShoppingCartOutlined />,
      label: "Generate Product QR",
    },

    {
      key: "dailysale",
      icon: <InboxOutlined />,
      label: "Daily Sales",
    },

        {
      key: "instantproducttransaction",
      icon: <InboxOutlined />,
      label: "Instant Transaction",
    },



    {
      key: "customerroyalty",
      icon: <ShoppingCartOutlined />,
      label: "Customer Royalty",
    },

        {
      key: "royaltyatmscan",
      icon: <ShoppingCartOutlined />,
      label: "Customer A.T.M",
    },

            {
      key: "customerroyaltydashboard",
      icon: <ShoppingCartOutlined />,
      label: "Customer Royalty Dashboard",
    },

    {
      key: "carpurchaseagreement",
      icon: <ShoppingCartOutlined />,
      label: "Car Purchase Agreement", 
    },

    {
      key: "purchasereciept",
      icon: <ReceiptLongOutlined />,
      label: "Car Purchase Reciept",
    },


    {
      key: "shippingtrip",
      icon: <TruckOutlined />,
      label: "Assign Trip",
    },

    {
      key: "createshipment",
      icon: <TruckOutlined />,
      label: "Goods Shiping",
    },

        {
      key: "goodsitemlist",
      icon: <TruckOutlined />,
      label: "Goods Listing",
    },

    {
      key: "shipingtriplist",
      icon: <TruckOutlined />,
      label: "Trip Status",
    },

    {
      key: "registeruser",
      icon: <TeamOutlined />,
      label: "Users Management",
    },

    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: "Reports",
    },

    {
      key: "prepaidcard",
      icon: <SettingOutlined />,
      label: "Card Payment",
    },
  ];

  // =========================================
  // SIDEBAR
  // =========================================
  const sidebarContent = (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: theme.sider,
      }}
    >
      {/* LOGO */}
      <div
        style={{
          padding: collapsed && screens.md
            ? "20px 10px"
            : "20px",

          borderBottom: `1px solid ${theme.border}`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: 44,
              height: 44,
              objectFit: "contain",
            }}
          />

          {(!collapsed || !screens.md) && (
            <div>
              <Title
                level={5}
                style={{
                  color: theme.text,
                  margin: 0,
                  lineHeight: 1.1,
                }}
              >
                Zulu Inventory
              </Title>

              <Text
                style={{
                  color: theme.textSecondary,
                  fontSize: 12,
                }}
              >
                Store Management
              </Text>
            </div>
          )}
        </div>
      </div>

      {/* USER CARD */}
      <div
        style={{
          padding: collapsed && screens.md
            ? 10
            : 18,
        }}
      >
        {/* <Card
          bordered={false}
          style={{
            borderRadius: 20,

            background: darkMode
              ? "linear-gradient(135deg,#0B6E4F,#14532D)"
              : "linear-gradient(135deg,#0B6E4F,#15803D)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
            }}
          >
            <Avatar
              size={
                collapsed && screens.md ? 42 : 52
              }
              icon={<UserOutlined />}
              style={{
                background: "#ffffff",
                color: "#0B6E4F",
              }}
            />

            {(!collapsed || !screens.md) && (
              <div>
                <div
                  style={{
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: 16,
                  }}
                >
                  Store Admin
                </div>

                <div
                  style={{
                    color:
                      "rgba(255,255,255,0.75)",
                    fontSize: 12,
                  }}
                >
                  Inventory & Sales Control
                </div>
              </div>
            )}
          </div>
        </Card> */}
        <div
  style={{
    padding: collapsed && screens.md ? 10 : 18,
  }}
>
<UserProfile
  darkMode={darkMode}
  collapsed={collapsed}
  screens={screens}
/>
</div>
      </div>

      {/* MENU */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "0 12px",
        }}
      >
        <Menu
          mode="inline"
          theme={darkMode ? "dark" : "light"}
          selectedKeys={[activeComponent]}
          inlineCollapsed={
            collapsed && screens.md
          }
          items={menuItems}
          onClick={({ key }) => {
            if (key === "products") {
              setProductPopup(true);
            } else {
              setActiveComponent(key);
            }

            if (!screens.md) {
              setDrawerVisible(false);
            }
          }}
          className="modern-admin-menu"
          style={{
            background: "transparent",
            border: "none",
          }}
        />
      </div>

      {/* ========================================= */}
        {/* MOBILE YEAR SELECTOR */}
        {/* ========================================= */}
        {!screens.md && (
          <div
            style={{
              padding:
                "6px 2px 18px 2px",
            }}
          >
            <div
              style={{
                background: darkMode
                  ? "rgba(255,255,255,0.04)"
                  : "#ffffff",

                border: `1px solid ${theme.border}`,

                borderRadius: 18,

                padding: 16,
              }}
            >
              <div
                style={{
                  color: theme.text,

                  fontWeight: 600,

                  fontSize: 14,

                  marginBottom: 12,
                }}
              >
                Financial Year
              </div>

              <YearSelector />
            </div>
          </div>
        )}
     

      {/* LOGOUT */}
 
      <div
  style={{
    padding: 16,
    borderTop: `1px solid ${theme.border}`,
  }}
>
  <Logout
    darkMode={darkMode}
    collapsed={collapsed}
    screens={screens}
    theme={theme}
  />
</div>
    </div>
  );

  // =========================================
  // CONTENT RENDER
  // =========================================
  const renderContent = () => {
    switch (activeComponent) {
      case "dashboard":
        return (
          <>
            {/* HEADER */}
            <div
              style={{
                marginBottom: 24,
              }}
            >
              <Title
                level={2}
                style={{
                  color: theme.text,
                  marginBottom: 4,
                }}
              >
                Store Overview Dashboard
              </Title>

              <Text
                style={{
                  color: theme.textSecondary,
                  fontSize: 15,
                }}
              >
                Monitor inventory, sales,
                purchases, and store
                performance
              </Text>
            </div>

            {/* KPI CARDS */}
            <DashboardCards
              setActiveComponent={
                setActiveComponent
              }
            />

            <Divider
              style={{
                borderColor: theme.border,
              }}
            />

            {/* ANALYTICS */}
            <Row gutter={[20, 20]}>
              <Col xs={24} lg={12}>
                <Card
                  style={{
                    borderRadius: 24,
                    background: theme.card,
                    border: `1px solid ${theme.border}`,
                  }}
                >
                  <Title
                    level={4}
                    style={{
                      color: theme.text,
                    }}
                  >
                    Inventory Health
                  </Title>

                  <div
                    style={{
                      marginTop: 20,
                    }}
                  >
                    <Text
                      style={{
                        color:
                          theme.textSecondary,
                      }}
                    >
                      Stock Availability
                    </Text>

                    <Progress percent={78} />
                  </div>

                  <div
                    style={{
                      marginTop: 20,
                    }}
                  >
                    <Text
                      style={{
                        color:
                          theme.textSecondary,
                      }}
                    >
                      Fast Moving Items
                    </Text>

                    <Progress percent={64} />
                  </div>

                  <div
                    style={{
                      marginTop: 20,
                    }}
                  >
                    <Text
                      style={{
                        color:
                          theme.textSecondary,
                      }}
                    >
                      Slow Moving Items
                    </Text>

                    <Progress
                      percent={32}
                      status="exception"
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} lg={12}>
                <Card
                  style={{
                    borderRadius: 24,
                    background: theme.card,
                    border: `1px solid ${theme.border}`,
                  }}
                >
                  <Title
                    level={4}
                    style={{
                      color: theme.text,
                    }}
                  >
                    Store Insights
                  </Title>

                  <div
                    style={{
                      marginTop: 18,
                      display: "flex",
                      flexDirection: "column",
                      gap: 14,
                    }}
                  >
                    {[
                      "Electronics top sales",
                      "Peak time 2PM - 6PM",
                      "Return rate 4.2%",
                      "Staff efficiency 87%",
                    ].map((item, index) => (
                      <div
                        key={index}
                        style={{
                          padding: 14,
                          borderRadius: 14,
                          background:
                            darkMode
                              ? "#172B24"
                              : "#F8FAF9",

                          border: `1px solid ${theme.border}`,
                        }}
                      >
                        <Text
                          style={{
                            color:
                              theme.text,
                          }}
                        >
                          {item}
                        </Text>
                      </div>
                    ))}
                  </div>
                </Card>
              </Col>
            </Row>
          </>
        );

      case "purchase":
        return <Purchase />;
        
      case "customerroyalty":
        return <CustomerRoyalty />;    

      case "royaltyatmscan":
        return <RoyaltyATMScan />; 

      case "generateproductqr":
        return <ProductQRCode />;

      case "customerroyaltydashboard":
        return <AdminCustomerTable />;
      
      case "carpurchaseagreement":
        return <CarPurchaseAgreement />; 


      
      case "purchasereciept":
        return <CarAgreementReceipt />;

      case "dailysale":
        return <DailySales />;  

            case "instantproducttransaction":
        return <InstantProductTransaction />;



      case "createshipment":   
        return <CreateShipment />; 

      case "goodsitemlist":   
        return <GoodsItemList />;

      case "shippingtrip":   
        return <ShippingTrip />; 

      case "shipingtriplist":
        return <ShippingTripList />;

      case "registeruser":
        return <UserManagement />;

      case "reports":
        return (
          <Card
            style={{
              borderRadius: 24,
              background: theme.card,
              border: `1px solid ${theme.border}`,
            }}
          >
            <Title
              level={3}
              style={{
                color: theme.text,
              }}
            >
              Reports Dashboard
            </Title>

            <Text
              style={{
                color:
                  theme.textSecondary,
              }}
            >
              Revenue and inventory
              reporting system.
            </Text>
          </Card>
        );

      case "prepaidcard":
        return <PrepaidCard />;

      case "productlist":
        return <ProductList />;

      default:
        return null;
    }
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background: theme.background,
      }}
    >
      {/* ========================================= */}
      {/* SIDEBAR DESKTOP */}
      {/* ========================================= */}
      {screens.md && (
        <Sider
          collapsed={collapsed}
          trigger={null}
          collapsedWidth={90}
          width={290}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            overflow: "hidden",
            background: theme.sider,
            borderRight: `1px solid ${theme.border}`,
            zIndex: 1001,
          }}
        >
          {sidebarContent}
        </Sider>
      )}

      {/* ========================================= */}
      {/* MOBILE DRAWER */}
      {/* ========================================= */}
      {!screens.md && (
        <Drawer
          placement="left"
          open={drawerVisible}
          onClose={() =>
            setDrawerVisible(false)
          }
          closable={false}
          width={290}
          bodyStyle={{
            padding: 0,
            background: theme.sider,
          }}
        >
          {sidebarContent}
        </Drawer>
      )}

      {/* ========================================= */}
      {/* MAIN */}
      {/* ========================================= */}
      <Layout
        style={{
          marginLeft: screens.md
            ? collapsed
              ? 90
              : 290
            : 0,

          transition: "all 0.3s ease",

          background: "transparent",
        }}
      >
        {/* ========================================= */}
        {/* HEADER */}
        {/* ========================================= */}
<Header
  style={{
    position: "sticky",
    top: 0,
    zIndex: 999,

    height: screens.xs ? 76 : 82,
    padding: screens.xs ? "0 12px" : "0 22px",

    background: theme.header,
    backdropFilter: "blur(16px)",
    borderBottom: `1px solid ${theme.border}`,

    display: "flex",
    alignItems: "center", // 🔥 IMPORTANT: ensures vertical alignment across ALL children
    justifyContent: "space-between",

    gap: screens.xs ? 10 : 18,
  }}
>
  {/* ========================================= */}
  {/* LEFT SIDE */}
  {/* ========================================= */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: screens.xs ? 10 : 16,
      flex: 1,
      minWidth: 0,
    }}
  >
    {/* SIDEBAR TOGGLE */}
    <Button
      type="text"
      icon={
        screens.md ? (
          collapsed ? (
            <MenuUnfoldOutlined />
          ) : (
            <MenuFoldOutlined />
          )
        ) : (
          <MenuUnfoldOutlined />
        )
      }
      onClick={() => {
        if (screens.md) {
          setCollapsed(!collapsed);
        } else {
          setDrawerVisible(true);
        }
      }}
      style={{
        width: 46,
        height: 46,
        borderRadius: 14,
        flexShrink: 0,
        color: theme.text,
        background: darkMode
          ? "rgba(255,255,255,0.05)"
          : "#ffffff",
        border: `1px solid ${theme.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />

    {/* LOGO */}
    <div
      style={{
        width: screens.xs ? 38 : 42,
        height: screens.xs ? 38 : 42,
        borderRadius: 12,
        overflow: "hidden",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: darkMode
          ? "rgba(255,255,255,0.04)"
          : "#ffffff",
        border: `1px solid ${theme.border}`,
      }}
    >
      <img
        src={logo}
        alt="logo"
        style={{
          width: "75%",
          height: "75%",
          objectFit: "contain",
        }}
      />
    </div>

    {/* TITLE AREA */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minWidth: 0,
        overflow: "hidden",
        lineHeight: 1.1,
      }}
    >
      <div
        style={{
          color: theme.text,
          fontWeight: 700,
          fontSize: screens.xs ? 15 : 20,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          letterSpacing: 0.2,
        }}
      >
        Store Admin Panel
      </div>

      {!screens.xs && (
        <div
          style={{
            color: theme.textSecondary,
            fontSize: 12,
            marginTop: 4,
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Inventory & Sales Control
        </div>
      )}
    </div>
  </div>

  {/* ========================================= */}
  {/* CENTER (YEAR SELECTOR - DESKTOP ONLY) */}
  {/* ========================================= */}
  {screens.lg && (
    <div
      style={{
        width: 220,
        flexShrink: 0,

        height: "100%", // 🔥 match header height
        display: "flex",
        alignItems: "center", // 🔥 vertical alignment fix
        justifyContent: "center",
      }}
    >
<div style={{ marginTop: "23px" }}>
  <YearSelector />
</div>
    </div>
  )}

  {/* ========================================= */}
  {/* RIGHT SIDE */}
  {/* ========================================= */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: screens.xs ? 8 : 14,
      flexShrink: 0,
    }}
  >
    {/* DARK MODE */}
    <div
      style={{
        padding: "8px 12px",
        borderRadius: 14,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: darkMode
          ? "rgba(255,255,255,0.05)"
          : "#ffffff",
        border: `1px solid ${theme.border}`,
      }}
    >
      <Switch
        checked={darkMode}
        onChange={() => setDarkMode(!darkMode)}
        checkedChildren="🌙"
        unCheckedChildren="☀️"
      />
    </div>

    {/* NOTIFICATIONS */}
    <Badge count={8}>
      <Button
        type="text"
        icon={<BellOutlined />}
        style={{
          width: 46,
          height: 46,
          borderRadius: 14,
          color: theme.text,
          background: darkMode
            ? "rgba(255,255,255,0.05)"
            : "#ffffff",
          border: `1px solid ${theme.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </Badge>

    {/* USER AVATAR */}
    <Avatar
      size={44}
      icon={<UserOutlined />}
      style={{
        background: theme.primary,
        flexShrink: 0,
        cursor: "pointer",
      }}
    />
  </div>
</Header>

        {/* ========================================= */}
        {/* CONTENT */}
        {/* ========================================= */}
        <Content
          style={{
            padding: screens.xs
              ? 14
              : 24,
          }}
        >
          {renderContent()}
        </Content>
      </Layout>

      {/* ========================================= */}
      {/* PRODUCT POPUP */}
      {/* ========================================= */}
      <AnimatePresence>
        {productPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,

              background:
                "rgba(0,0,0,0.55)",

              backdropFilter:
                "blur(6px)",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              padding: 20,

              zIndex: 2000,
            }}
          >
            <motion.div
              initial={{
                scale: 0.8,
                opacity: 0,
                y: 40,
              }}
              animate={{
                scale: 1,
                opacity: 1,
                y: 0,
              }}
              exit={{
                scale: 0.8,
                opacity: 0,
              }}
              transition={{
                duration: 0.3,
              }}
              style={{
                width: "100%",
                maxWidth: 1200,

                maxHeight: "92vh",

                overflowY: "auto",

                background:
                  theme.card,

                borderRadius: 28,

                position: "relative",

                padding: screens.xs
                  ? 14
                  : 24,

                border: `1px solid ${theme.border}`,
              }}
            >
              {/* CLOSE BTN */}
              <Button
                shape="circle"
                icon={<CloseOutlined />}
                onClick={() =>
                  setProductPopup(
                    false
                  )
                }
                style={{
                  position: "absolute",
                  top: 18,
                  right: 18,

                  width: 42,
                  height: 42,

                  zIndex: 20,
                }}
              />

              <Product />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ========================================= */}
      {/* STYLES */}
      {/* ========================================= */}
      <style>{`
        .modern-admin-menu .ant-menu-item {
          height: 52px !important;
          line-height: 52px !important;
          border-radius: 14px !important;
          margin: 8px 0 !important;
          font-size: 15px !important;
          font-weight: 500 !important;
        }

        .modern-admin-menu .ant-menu-item .anticon {
          font-size: 18px !important;
        }

        .modern-admin-menu .ant-menu-item-selected {
          background: linear-gradient(
            135deg,
            #0B6E4F,
            #15803D
          ) !important;

          color: #ffffff !important;
          font-weight: 700 !important;
        }

        .modern-admin-menu .ant-menu-item-selected::after {
          display: none !important;
        }

        .modern-admin-menu .ant-menu-item:hover {
          background: rgba(11,110,79,0.12) !important;
        }

        .ant-layout-sider-trigger {
          display: none !important;
        }

        .ant-drawer-content {
          background: ${theme.sider} !important;
        }

        .ant-menu-dark,
        .ant-menu-light {
          background: transparent !important;
        }

        @media (max-width: 768px) {
          .modern-admin-menu .ant-menu-item {
            height: 50px !important;
            line-height: 50px !important;
            font-size: 15px !important;
          }
        }

        @media (max-width: 480px) {
          .modern-admin-menu .ant-menu-item {
            font-size: 14px !important;
          }
        }
      `}</style>
    </Layout>
  );
};

export default AdminDashboard;

